<div class="modal-header">
  <div>
    <h4 class="modal-title">
      {{ editable ? 'Editar amonestación' : noticeViolation.title }}
    </h4>
    <span
      class="badge"
      [ngClass]="noticeViolation.status ? 'text-bg-success' : 'text-bg-secondary'">
      {{ noticeViolation.status ? 'Activa' : 'Inactiva' }}
    </span>
  </div>
  <button
    type="button"
    class="btn-close"
    aria-label="Cerrar"
    (click)="activeModal.dismiss('Cross click')"></button>
</div>

<div class="modal-body">
  <div class="container-fluid">
    <div class="row">

      <div class="col-12 col-md-6 mb-3">
        <div class="text-secondary"><small><b>Casa</b></small></div>
        <div>
          {{ noticeViolation.houseLabel }}
          @if (noticeViolation.houseFlat?.fullName) {
            <small class="text-secondary"> &ndash; {{ noticeViolation.houseFlat?.fullName }}</small>
          }
        </div>
      </div>

      <div class="col-12 col-md-6 mb-3">
        <div class="text-secondary"><small><b>Fecha</b></small></div>
        <div>
          {{ noticeViolation.createdAt | dateToMoment: 'DD MMM YYYY HH:mm' : neighborhoodService.currentNeighborhood?.timeZone }}
          @if (noticeViolation.createdBy) {
            <small class="text-secondary"> &middot; {{ noticeViolation.createdBy.fullName }}</small>
          }
        </div>
      </div>

      @if (editable) {

        <form
          id="formNoticeViolation"
          class="col-12"
          [formGroup]="formNoticeViolation"
          (ngSubmit)="save()">

          <div class="mb-3 form-group">
            <label for="title" class="form-label">Título</label>
            <input
              type="text"
              id="title"
              class="form-control"
              formControlName="title"
              [maxlength]="titleMaxLength"
              [ngClass]="{
                'is-invalid': submitted && formControls['title'].errors
              }">
            <div class="d-flex justify-content-between">
              <div>
                @if (submitted && formControls['title'].errors) {
                  <div class="text-danger small mt-1">
                    Por favor, ingrese el título de la amonestación
                  </div>
                }
              </div>
              <small class="text-secondary mt-1">
                {{ titleLength }}/{{ titleMaxLength }}
              </small>
            </div>
          </div>

          <div class="mb-3 form-group">
            <label for="description" class="form-label">Descripción</label>
            <textarea
              id="description"
              class="form-control"
              formControlName="description"
              rows="5"
              [ngClass]="{
                'is-invalid': submitted && formControls['description'].errors
              }"></textarea>
            @if (submitted && formControls['description'].errors) {
              <div class="invalid-feedback d-block">
                Por favor, ingrese la descripción de la amonestación
              </div>
            }
          </div>

          <div class="mb-3 d-flex align-items-center justify-content-between gap-3">
            <label for="status" class="form-label mb-0">
              Amonestación activa
            </label>
            <p-inputSwitch
              inputId="status"
              formControlName="status"></p-inputSwitch>
          </div>

        </form>

      } @else {

        <div class="col-12 text-secondary">
          <small><b>Descripción</b></small>
        </div>
        <div class="col-12 mb-3 description-text">
          {{ noticeViolation.description }}
        </div>

      }

      <div class="col-12 text-secondary mb-1">
        <small><b>Archivos ({{ noticeViolation.files.length }})</b></small>
      </div>

      @if (noticeViolation.files.length === 0) {
        <div class="col-12 mb-3 text-secondary">
          Esta amonestación no tiene archivos.
        </div>
      }

      @if (noticeViolation.images.length > 0) {
        <div class="col-12 mb-3">
          <div class="row">
            <!-- La miniatura es un <button> y no un p-image con [preview]: el
                 preview de p-image abre un visor aislado por foto, sin forma
                 de pasar a la siguiente. Aquí el click abre el p-galleria a
                 pantalla completa en el índice correcto (mismo patrón que
                 report-modal). -->
            @for (item of images; track item.fileId) {
              <div class="col-12 col-sm-6 mb-2 position-relative">
                <button
                  #photoThumb
                  type="button"
                  class="notice-thumb"
                  [attr.aria-label]="'Abrir ' + photoAlt($index)"
                  (click)="openViewer($index)">

                  <img
                    class="notice-thumb-image"
                    [src]="item.urlFile"
                    [alt]="photoAlt($index)"
                    loading="lazy" />

                  <span class="notice-thumb-overlay" aria-hidden="true">
                    <i class="pi pi-search-plus"></i>
                  </span>

                </button>
                @if (editable) {
                  <button
                    type="button"
                    class="btn btn-danger btn-sm notice-thumb-delete position-absolute top-0 end-0 m-2 me-3 rounded-circle"
                    aria-label="Quitar foto"
                    (click)="deleteFile(item)">
                    <i class="material-icons mt-1">delete</i>
                  </button>
                }
              </div>
            }
          </div>

          <!-- Visor a pantalla completa. Los pTemplate NO pueden ir dentro de
               un @if: la consulta ContentChildren de PrimeNG solo mira hijos
               directos. Las condiciones van dentro de cada template. -->
          <p-galleria
            [value]="images"
            [activeIndex]="viewerIndex"
            (activeIndexChange)="viewerIndex = $event"
            [visible]="viewerVisible"
            (visibleChange)="onViewerVisibleChange($event)"
            [fullScreen]="true"
            [circular]="hasManyImages"
            [showItemNavigators]="hasManyImages"
            [showItemNavigatorsOnHover]="false"
            [showIndicators]="showViewerIndicators"
            [showThumbnails]="false"
            [baseZIndex]="2000">

            <ng-template pTemplate="item" let-file>
              <img
                class="notice-viewer-image"
                [src]="file.urlFile"
                [alt]="photoAltOf(file)" />
            </ng-template>

            <ng-template pTemplate="footer">
              @if (hasManyImages) {
                <div class="notice-viewer-counter" aria-live="polite">
                  {{ viewerIndex + 1 }} de {{ images.length }}
                </div>
              }
            </ng-template>

          </p-galleria>
        </div>
      }

      @if (noticeViolation.pdfs.length > 0) {
        <div class="col-12 mb-3">
          <ul class="list-group">
            @for (item of noticeViolation.pdfs; track item.fileId) {
              <li class="list-group-item d-flex align-items-center gap-2">
                <i class="material-icons text-danger">picture_as_pdf</i>
                <a
                  class="flex-grow-1 text-truncate"
                  [href]="item.urlFile"
                  target="_blank"
                  rel="noopener">
                  Ver documento PDF
                </a>
                @if (editable) {
                  <button
                    type="button"
                    class="btn btn-sm btn-light rounded-circle flex-shrink-0"
                    aria-label="Quitar PDF"
                    (click)="deleteFile(item)">
                    <i class="material-icons mt-1">delete</i>
                  </button>
                }
              </li>
            }
          </ul>
        </div>
      }

      @if (editable) {
        <div class="col-12 mb-2">
          <div class="d-flex flex-wrap gap-2">
            <button
              type="button"
              class="btn btn-outline-primary d-flex align-items-center gap-1"
              (click)="compressFile()">
              <i class="material-icons">image</i>
              Agregar fotos
            </button>
            <button
              type="button"
              class="btn btn-outline-primary d-flex align-items-center gap-1"
              (click)="pdfInput.click()">
              <i class="material-icons">picture_as_pdf</i>
              Agregar PDF
            </button>
            <input
              #pdfInput
              type="file"
              class="d-none"
              accept="application/pdf"
              multiple
              (change)="onPdfChange($event)">
          </div>
          <small class="text-secondary d-block mt-1">
            PDF de máximo {{ noticeViolationService.maxPdfSizeMB }} MB. Los archivos se suben al instante.
          </small>
        </div>
      }

    </div>
  </div>
</div>

<div class="modal-footer">
  @if (editable) {
    <div class="col-12 my-3">
      <button
        (click)="activeModal.close()"
        type="button"
        class="btn btn-outline-danger w-100">
        Cancelar
      </button>
    </div>
    <div class="col-12">
      <button
        type="submit"
        form="formNoticeViolation"
        class="btn btn-primary w-100">
        Guardar cambios
      </button>
    </div>
  } @else {
    <div class="col-12 my-3">
      <button
        (click)="activeModal.close()"
        type="button"
        class="btn btn-primary w-100">
        OK
      </button>
    </div>
  }
</div>
